import { render, staticRenderFns } from "./deductionList-situation.vue?vue&type=template&id=f258c984&scoped=true"
import script from "./deductionList-situation.vue?vue&type=script&lang=js"
export * from "./deductionList-situation.vue?vue&type=script&lang=js"
import style0 from "./deductionList-situation.vue?vue&type=style&index=0&id=f258c984&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f258c984",
  null
  
)

export default component.exports